import { SecondaryProductSummarySkeleton } from 'components/secondaryMarket/shared/sections/SecondaryProductSummary.skeleton';
import { FC } from 'react';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';

import { LiveSalesMarginInformationMarginSkeleton } from '../../Workspaces/SecondaryMarketPostEvent/Tabs/live/sections.ts/LiveSalesMarginInformation.skeleton';
import { SecondaryBookingInformationSkeleton } from '../shared/sections/SecondaryBookingInformation.skeleton';
import { SecondaryTradeInformationSkeleton } from '../shared/sections/SecondaryTradeInformation.skeleton';

export const LiveFormContentSkeleton: FC<{ workspaceType: SecondaryWorkspaceType }> = ({ workspaceType }) => (
  <>
    <SecondaryProductSummarySkeleton />
    <SecondaryTradeInformationSkeleton />
    {workspaceType === 'secondaryMarketPostEvents' && <LiveSalesMarginInformationMarginSkeleton />}
    <SecondaryBookingInformationSkeleton />
  </>
);

LiveFormContentSkeleton.displayName = 'LiveFormContentSkeleton';
